import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
  * {
    box-sizing: border-box;
    padding: 0;
    margin: 0;
    font-family: "Poppins", sans-serif;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }

  body {
    background: url( ${({ theme }) =>
      theme.backgroundImagePath}) top / cover no-repeat fixed rgb(30,38,56);

    @media screen and (max-width: 769px) {
      background: ${(props) => props.theme.colors.bodyBg};
    }
  }
  body, #root {
    min-height: 100vh;
  }
  .pages-top-margin {
    margin-top: 63px;
    padding-bottom: 1rem;

    @media screen and (max-width: 769px) {
      margin-top: 53px;
    }
  }

  .wallet-address-button {
    background-color: transparent;
    border-radius: 7px;
    cursor: pointer;
    border: 1px solid;
    padding: 8px 12px;
    display: flex;
    align-items: center;--
    justify-content: center;
    gap: 2rem;
  }
  .loading-wrapper {
    height: 100vh;
    display: grid;
    place-content: center;
    .lds-ring {
      display: inline-block;
      position: relative;
      width: 80px;
      height: 80px;
    }
    .lds-ring div {
      box-sizing: border-box;
      display: block;
      position: absolute;
      width: 64px;
      height: 64px;
      margin: 8px;
      border: 4px solid ${({ theme }) => theme.colors.ellipse_20};
      border-radius: 50%;
      animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
      border-color: ${({ theme }) =>
        theme.colors.ellipse_20} transparent transparent transparent;
    }
    .lds-ring div:nth-child(1) {
      animation-delay: -0.45s;
    }
    .lds-ring div:nth-child(2) {
      animation-delay: -0.3s;
    }
    .lds-ring div:nth-child(3) {
      animation-delay: -0.15s;
    }
    @keyframes lds-ring {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }

  .full-screen-center {
    height: 100vh;
    display: grid;
    place-content: center;
  }
  .open-metamasl-mobile {
    height: 100vh;
    display: grid;
    place-content: center;
    > div {
      width: 100vw;
      text-align: center;
    }
    button {
      cursor: pointer;
      border: 1px solid #0b225c;
      border-radius: 8px;
      padding: 6px 0;
      max-width: 200px;
      width: 100%;
      color: #fff;
      background: linear-gradient(90deg, #163193 0%, #122972 100%);
    }
  }
  #connect-wallet {
    cursor: pointer;
    background-color: ${({ theme }) => theme.colors.ellipse_23};
    color: ${({ theme }) => theme.colors.ellipse_24};
    margin: 0;
    font-weight: 500;
    border: 0;
    border-radius: 7px;
    padding: 0.6rem 1rem;
    max-width: 150px;
    width: 150px;
  }
  .how-to-use-metamask {
    color: #ffff;
  }
  .card-custom-footer button {
    cursor: pointer;
    width: 100%;
    height: 32px;
    border: 0;
    background: linear-gradient(90deg, #163193 0%, #122972 100%);
    border-radius: 6px;
    padding: 0px 9.71076px;
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 20px;
    color: #ffffff;
    :disabled {
      background: #58709E;
      pointer-events: none;
    }
  }
  .arrows-action {
    width: 100%;
    display: flex;
    justify-content: space-between;
    > div {
      color: #fff;
      cursor: pointer;
      z-index: 1;
      top: 40%;
      right: 10px;
      left: unset;
      :last-child {
        left: 10px;
        right: unset;
      }
      position: absolute;
      display: grid;
      place-items: center;
      border-radius: 50%;
      width: 30px;
      height: 30px;
      background: #160044a6;
      transform: matrix(-1, 0, 0, 1, 0, 0);
      i {
        font-size: 14px;
      }
    }
  }
  .active-slide-name {
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.ellipse_20};
    margin-top: 1.5rem;
    text-align: center;
  }
  .swiper {
    width: 100%;
    padding-top: 30px;
    padding-bottom: 75px;
  }
  .swiper-slide {
    background-position: center;
    background-size: cover;
    width: 129.7px;
    height: 170.74px;
  }
  .swiper-slide img {
    display: block;
    width: 100%;
  }
  .ReactModal__Overlay {
    z-index: 99999;
    .ConnectWalletModal {
      background: ${({ theme }) => theme.colors.ellipse_3} !important;
      box-shadow: ${({ theme }) => theme.colors.ellipse_32};
      padding: 0 !important;
      .modal-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #ffffff17;
        padding-bottom: 0 !important;
        color: ${({ theme }) => theme.colors.ellipse_20};
        button {
          cursor: pointer;
          color: ${({ theme }) => theme.colors.ellipse_1};
        }
      }
      .connect-wallet-modal-body, .modal-header {
        padding: 13px;
      }
      .connect-wallet-modal-body {
        display: flex;
        flex-direction: column;
        gap: 7px;
        button {
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 5px;
          background: transparent;
          border-radius: 7px;
          color: ${({ theme }) => theme.colors.ellipse_24};
          padding: 10px 0;
          border: 1px solid ${({ theme }) => theme.colors.ellipse_1};
        }
      }
    }
    .ReactModal__Content:not(.ConnectWalletModal)  {
      background: ${({ theme }) => theme.colors.ellipse_3} !important;
      box-shadow: ${({ theme }) => theme.colors.ellipse_32};
      text-align: center;
      p {
        font-style: normal;
        font-weight: 400;
        font-size: 13px;
        line-height: 20px;
        color: ${({ theme }) => theme.colors.ellipse_33};
      }
      .actions {
        display: flex;
        flex-direction: column;
        gap: 6px;
        width: 100%;
      }
      button {
        border: 0;
        background: transparent;
        cursor: pointer;
        width: 100%;
        height: 32px;
        border-radius: 6px;
      }
      .submit-button {
        color: #fff;
        background: linear-gradient(90deg, #163193 0%, #122972 100%);
      }
      .cancel-button {
        color: #7094D8;
        border: 1px solid #7094D8;
      }
    }
  }
  .walletconnect-modal__mobile__toggle {
    display: none !important;
  }
  /* @media screen and (min-width: 1800px) {
    .bootstrap-wrapper .container {
      max-width: 1600px;
    }
  } */
  @media screen and (max-width: 770px) {
    .nav-container .brand {
      width: 95px !important;
      max-width: 95px !important;
      min-width: 95px !important;
    }
    .bootstrap-wrapper .container {
      max-width: 500px !important;
    }
    .bootstrap-wrapper .col-md-7 {
      flex: unset;
      max-width: unset;
    }
  }
`;
